module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many thanks to:")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Julie Lynch, archivist at the Sulzer Regional Library, for her tireless assistance;")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Former Sulzer Regional Library director Leah Steele for her guidance and encouragement;")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("The Ravenswood–Lake View Historical Association;")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("The Chicago History Museum Library;")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("My daughter Kathleen Butler Greenan, son-in-law Ryan Greenan and Chicago author Richard Lindberg for their support, each in their own inimitable ways; and to F. Bryan Pickett for technical support.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("And The History Press, especially Ben Gibson, my commissioning editor, for making this happen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5abd810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 69
// module chunks = 0